import React, { Component } from "react";
import i18n from "i18next";
import axios from "axios";
import Chart5 from "./../Components/Charts/Chart5";
import "./CommentaryWidget.css";
import Navbar from "../Components/Navbar";
import { ccy2cc, getURLParameters } from "../lib/utils";
import VideoBox from "../Components/Commentary/VideoBox";
import TrendIcon from "../Components/Commentary/TrendIcon";

const ccyList = ["USD", "EUR", "GBP", "AUD", "NZD", "CAD", "JPY", "CHF"];
const selectList = [
  "ALL",
  "USD",
  "EUR",
  "GBP",
  "AUD",
  "NZD",
  "CAD",
  "JPY",
  "CHF",
];

export default class CommentaryWidget extends Component<any, any> {
  chartRef: any;

  constructor(props: any) {
    super(props);
    this.chartRef = React.createRef();
    this.state = {
      token: this.props.token,
      lang: this.props.lang,
      FXdata: [],
      MPdata: [],
      ccy: "ALL",
      selectedccy: "ALL",
      cc: "",
      compare: "",
      type: "",
      overlay: "",
      overlayConfig: "",
      tapane: "",
      tapaneConfig: "",
      period: "3M",
      ccyList: [],
    };
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.updateDimensions);
    this.props.history.push(
      "/commentary?lang=" + this.props.lang + "&cc=" + this.props.cc
    );

    this.GetCCYList(this.props);
    this.ForeignExchangeAPI(this.props);
    this.MarketProspectAPI(this.props);
    this.props.widget(true);
  };

  componentWillReceiveProps(nextProps: any) {
    if (nextProps.lang !== this.props.lang) {
      this.props.history.push(
        "/commentary?lang=" + nextProps.lang + "&cc=" + nextProps.cc
      );
      this.setState({ lang: nextProps.lang });
      this.ForeignExchangeAPI(nextProps);
      this.MarketProspectAPI(nextProps);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions = () => {
    this.chartRef.current.resizeChart("");
  };

  fitAPIlang = () => {
    if (this.state.lang === "en") {
      return "en_US";
    } else {
      return this.state.lang;
    }
  };

  GetCCYList(props: any) {

    let base_url = this.props.domain + "/bochkfxwidget/data/commentary?";

    let url =
      base_url +
      "type=CCYList" +
      "&lang=" +
      this.props.lang +
      "&cc=" +
      this.state.cc +
      "&token=" +
      this.state.token +
      "&_=" + new Date().getTime();

    axios.get(url).then((res) => {
      this.UpdateCCYList(res.data);
    });
    // const param = {
    //   token: props.token,
    //   lang: props.lang,
    //   type: "CCYList",
    //   cc: this.state.cc,
    //   _: new Date().getTime(),
    // };

    // let address = APIAddress.commentary;
    // const raw = DataLoader(address, param);

    // raw.then((data) => {
    //   console.log(data);
    //   this.UpdateCCYList(data);
    // });
  }

  UpdateCCYList(list: any) {
    let newCCYList = list.split(",");
    let ccyList = new Array();
    ccyList.push("ALL");

    newCCYList.forEach((ccy: any) => {
      if (ccy != "" && ccy !="Gold") {
        ccyList.push(ccy);
      }
    });
    this.setState({ ccyList: ccyList });
  }

  ForeignExchangeAPI(props: any) {

    let base_url = this.props.domain + "/bochkfxwidget/data/commentary?";

    let url =
      base_url +
      "type=ForeignExchange" +
      "&lang=" +
      this.props.lang +
      "&cc=" +
      this.state.cc +
      "&token=" +
      this.state.token +
      "&_=" + new Date().getTime();

    axios.get(url).then((res) => {
      this.setState({ FXdata: { status: "loaded", payload: res.data } });
    });
  }

  MarketProspectAPI(props: any) {

    let base_url = this.props.domain + "/bochkfxwidget/data/commentary?";

    let url =
      base_url +
      "type=MarketProspect" +
      "&lang=" +
      this.props.lang +
      "&cc=" +
      this.state.cc +
      "&token=" +
      this.state.token +
      "&_=" + new Date().getTime();

    axios.get(url).then((res) => {
      this.setState({ MPdata: { status: "loaded", payload: res.data } });
    });
  }

  changeSelect = (event: React.FormEvent<HTMLSelectElement>) => {
    this.setState({ ccy: event.currentTarget.value });
  };

  getChartCurrency = (ccy: string) => {
    switch (ccy) {
      case "USD":
        return ".DXY";
      case "EUR":
        return "EURUSD";
      case "GBP":
        return "GBPUSD";
      case "AUD":
        return "AUDUSD";
      case "NZD":
        return "NZDUSD";
      case "CAD":
        return "USDCAD";
      case "JPY":
        return "USDJPY";
      case "CHF":
        return "USDCHF";
      default:
        return "";
    }
  };

  createForecast = () => {
    if (this.state.MPdata && this.state.MPdata.status === "loaded") {

      //get video sort order desc
      var sortList: string[] = [];
      if (this.state.FXdata && this.state.FXdata.status === "loaded") {
        let data = this.state.FXdata.payload.result[this.fitAPIlang()];
        // for (let i = 0; i < data.length; i++) {
        //   let video = data[i];
        //   if (data[i].category === "fx_daily") {
        //     sortList.splice(0, 0, video.tag);
        //   }
        // }

        var list = data.sort((a: any, b: any) => (a["sortingDate"] > b["sortingDate"]) ? 1 : -1)
        for (let i = 0; i < list.length; i++) {
          let video = data[i];
          if (data[i].category === "fx_daily" && data[i].tag != "Gold") {
            sortList.splice(0, 0, video.tag);
          }
        }
        // list.forEach((e:any) => {
        //   if (e.category === "fx_daily") {
        //     sortList.splice(e.tag);
        //   }
        // });
      }

      //get latest data
      var data = this.state.MPdata.payload;
      // var latestDateIndex = -1;
      var latestDateIndex = 0;
      // var latest = data.result[this.fitAPIlang()][0]["sortingDate"];
      // for (let i = 1; i < data.result[this.fitAPIlang()].length; i++) {
      //   if (latest > data.result[this.fitAPIlang()][i]["sortingDate"]) {
      //   } else {
      //     latest = data.result[this.fitAPIlang()][i]["sortingDate"];
      //     latestDateIndex = i;
      //   }
      // }

      var list = data.result[this.fitAPIlang()].sort((a: any, b: any) => (a["sortingDate"] < b["sortingDate"]) ? 1 : -1)
      //console.log(list)
      //console.log(list[0]["array"])


      //sort latest data
      let dataList: any[] = [];
      // sortList.forEach((s: any) => {
      //   for (let i = 0; i < data.result[this.fitAPIlang()][latestDateIndex].length; i++) {
      //     if (data.result[this.fitAPIlang()][latestDateIndex]["array"][i]["id"] === s) {
      //       dataList.push(data.result[this.fitAPIlang()][latestDateIndex]["array"][i])
      //     }
      //   }
      // });

      for (let s = 0; s < sortList.length; s++) {

        for (let i = 0; i < list[0]["array"].length; i++) {
          if (list[0]["array"][i]["id"] == sortList[s]) {
            //console.log(sortList[s])
            //console.log(list[0]["array"][i]["id"])
            dataList.push(list[0]["array"][i])
          }
        }
      }

      // sortList.forEach((s: any) => {
      //   for (let i = 0; i < list[0].length; i++) {
      //     console.log(list[0]["array"][i]["id"])
      //     console.log(s)
      //     if(list[0]["array"][i]["id"] == s){
      //       dataList.push(list[0]["array"][i])
      //     }
      //   }
      // })

      //console.log(sortList)
      //console.log(dataList)

      return (
        <div>
          {sortList.map((item: any, idx: any) => {
            if (item.id !== "Gold") {
              return this.renderForecast(dataList, latestDateIndex, idx, item, sortList);
            }
          })}
        </div>
      );
    }
  };

  renderForecast(
    data: any,
    latestDateIndex: number,
    curIndex: number,
    ccy: string,
    newCCYList: any
  ) {
    return (
      <div className="Commentary-Forecast" key={curIndex}>
        {(this.state.selectedccy == "ALL" || this.state.selectedccy == ccy) && (
          <div className="Commentary-Forecast">
            <div className="Commentary-Forecast-Tag">
              {i18n.t("Common." + ccy)}
            </div>
            <div className="Commentary-Forecast-Table">
              <div className="Commentary-Forecast-Table-Row">
                <div className="Commentary-Forecast-Table-Cell">
                  {this.renderDailyVideo(ccy)}
                </div>
                <div className="Commentary-Forecast-Table-Cell">
                  <div className="Commentary-Forecast-Table-Chart">
                    <div style={{ width: "100%", height: "300px", backgroundColor: "transparent", zIndex: 100, position: "absolute" }}></div>
                    <Chart5
                      ref={this.chartRef}
                      token={this.props.token}
                      fontsize={this.props.fontsize}
                      noCrosshair={true}
                      enableScrollPane={false}
                      full={this.state.fullChart}
                      ccy={this.getChartCurrency(ccy)}
                      compare=""
                      type="candlestick"
                      overlay=""
                      overlayConfig=""
                      tapane=""
                      tapaneConfig=""
                      period="3M"
                      domain={this.props.domain}
                    />
                  </div>
                  <div className="AnalysisBox-Footer">
                    <div
                      className="AnalysisBox-Footer-Disclaimer"
                      dangerouslySetInnerHTML={{
                        __html: i18n.t("News.Commentary.Disclaimer", ""),
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Commentary-Forecast-Content">
              {curIndex !== -1 && (
                <div className="Commentary-Table">
                  <div className="Commentary-Table-Row">
                    <div className="Commentary-Table-Col1">
                      {i18n.t("News.Commentary.EstimateDirection")}
                    </div>

                    <div className="Commentary-Table-Col2">
                      {
                        <TrendIcon
                          direction={
                            data[curIndex]["expectedDirection"]
                          }
                        />
                      }
                    </div>
                  </div>
                  <div className="Commentary-Table-Row">
                    <div className="Commentary-Table-Col1">
                      {i18n.t("News.Commentary.MarketSpot")}
                    </div>
                    <div
                      className="Commentary-Table-Col2"
                      dangerouslySetInnerHTML={{
                        __html:
                          data[curIndex]["focus"],
                      }}
                    ></div>
                  </div>
                  <div className="Commentary-Table-Row">
                    <div className="Commentary-Table-Col1">
                      {i18n.t("News.Commentary.Trend")}
                    </div>
                    <div
                      className="Commentary-Table-Col2"
                      dangerouslySetInnerHTML={{
                        __html:
                          data[curIndex]["trend"],
                      }}
                    ></div>
                  </div>
                  <div className="Commentary-Table-Row">
                    <div className="Commentary-Table-Col1">
                      {i18n.t("News.Commentary.Support")}
                    </div>
                    <div className="Commentary-Table-Col2">
                      {
                        data[curIndex]["support"]
                      }
                    </div>
                  </div>
                  <div className="Commentary-Table-Row">
                    <div className="Commentary-Table-Col1">
                      {i18n.t("News.Commentary.Resistance")}
                    </div>
                    <div className="Commentary-Table-Col2">
                      {
                        data[curIndex]["resistance"]
                      }
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  parseVideoDate(value: string) {
    if (value && value.length === 19) {
      // let d = new Date(value);

      return (
        value.substring(0, 4) +
        "/" +
        value.substring(5, 7) +
        "/" +
        value.substring(8, 10)
      );
    }
    return "";
  }

  renderWeeklyVideo() {
    if (this.state.FXdata && this.state.FXdata.status === "loaded") {
      let data = this.state.FXdata.payload.result[this.fitAPIlang()];
      for (let i = 0; i < data.length; i++) {
        let video = data[i];
        if (video.category === "fx_weekly") {
          let lang = video.languageText;
          let fullDescText = video.fullDescText;
          let desc = [];
          while (fullDescText.length > 0) {
            let startidx = fullDescText.indexOf("<p>");
            let endidx = fullDescText.indexOf("</p>");
            desc.push(
              fullDescText.substr(startidx + 3, endidx - (startidx + 3))
            );
            fullDescText = fullDescText.substr(endidx + 4).trim();
          }

          return (
            <div className="Commentary-Forecast-Video">
              <div className="Commentary-Forecast-Video-box">
                <VideoBox
                  category=""
                  lang={lang}
                  // speaker={desc[0]}
                  // content={desc[1]}
                  title={video.titleText}
                  video={video.videoURL}
                  thumbnail={video.videoThumbnail}
                  date={this.parseVideoDate(video.sortingDate)}
                />
              </div>
              <div className="Commentary-Forecast-Weekly">
                <div className="Commentary-Forecast-Weekly-Box">
                  <div className="Commentary-Forecast-Weekly-speaker">
                    {desc[0]}
                  </div>
                  <div className="Commentary-Forecast-Weekly-content">
                    {desc[1]}
                  </div>
                </div>
              </div>
            </div>
          );
        }
      }
    }
  }

  renderDailyVideo(ccy: any) {
    let renderCCY = ccy;
    if (this.state.FXdata && this.state.FXdata.status === "loaded") {
      let data = this.state.FXdata.payload.result[this.fitAPIlang()];
      for (let i = 0; i < data.length; i++) {
        let video = data[i];
        if (data[i].category === "fx_daily" && video.tag === renderCCY) {
          let lang = video.languageText;

          let fullDescText = video.fullDescText;
          let desc = [];
          while (fullDescText.length > 0) {
            let startidx = fullDescText.indexOf("<p>");
            let endidx = fullDescText.indexOf("</p>");
            desc.push(
              fullDescText.substr(startidx + 3, endidx - (startidx + 3))
            );
            fullDescText = fullDescText.substr(endidx + 4).trim();
          }
          return (
            <div className="CommentaryWidget-Videos">
              <VideoBox
                lang={lang}
                speaker={desc[0]}
                content={desc[1]}
                title={video.titleText}
                video={video.videoURL}
                thumbnail={video.videoThumbnail}
                date={this.parseVideoDate(video.sortingDate)}
              />
            </div>
          );
        }
      }
    }
  }

  changeSelectCurrency = (event: React.FormEvent<HTMLSelectElement>) => {
    var current_cc = ccy2cc(event.currentTarget.value);
    this.setState({
      selectedccy: event.currentTarget.value,
      cc: current_cc,
      ccy: event.currentTarget.value,
    });
  };

  // JSX of select list
  RegionList = () => {
    const list = this.state.ccyList;

    return (
      <select
        onChange={(e) => this.changeSelectCurrency(e)}
        value={this.state.ccy}
      >
        {list.map(function (item: any, i: number) {
          return (
            <option key={i} value={item}>
              {i18n.t("Common." + item)}
            </option>
          );
        })}
      </select>
    );
  };

  openNewWindow = () => {
    var lang = getURLParameters("lang");
    var cc = getURLParameters("cc");
    window.open(
      "/bochkfxibs/riskDisclosure?lang=" + lang + "&cc=" + cc,
      "_blank",
      " left=50%, top=50%, width=1024, height=680, scrollbars=1"
    );
  };

  render() {
    return (
      <div style={{ fontSize: this.props.fontSize || "100%" }}>
        <Navbar lang={this.props.lang} cc={this.props.cc} />
        <div className="content">
          <div className="title">{i18n.t("Commentary.Title")}</div>
          <div className="select_container">
            {i18n.t("Common.Currency")}
            <this.RegionList />
          </div>
          {this.createForecast()}
        </div>
      </div>
    );
  }
}
